module.exports = __webpack_public_path__ + "img/city10.00feecef.png";